import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import { environment } from "@environments/environment";
import AdminDashboard from "@pages/admindashboard/AdminDashboard";
import EvaluatorPage from "@pages/evaluatorpage/EvaluatorPage";
import Header from "@components/header/Header";
import CreateTest from "@pages/createtest/CreateTest";
import HomePage from "@pages/homepage/HomePage";
import EvaluatorLandingPage from "@pages/evaluatorlandingpage/EvaluatorLandingPage";
import AnswerSheetUpload from "@pages/answersheetupload/AnswerSheetUpload";
import EvaluatorDashboard from "@pages/evaluatordashboard/EvaluatorDashboard";
import ExamSession from "@pages/examsession/ExamSession";
import AuthGuard from "@components/authguard/Authguard";
import { Providers } from "./Provider";
import { useShortcutHints } from "@hooks/useShortCutHints";
import "./App.css";

function AppContent() {
  const location = useLocation();
  useShortcutHints();
  const hideHeaderOnPaths = [""];
  console.log("path name",location.pathname);
  return (
    <>
    <div className="appLayout">
      {!hideHeaderOnPaths.includes(location.pathname) && <Header />}
      <div className="pageContainer">
      <Routes>
        <Route
          path="/admin-dashboard"
          element={
            <AuthGuard allowedRoles={[environment.ROLE_IDS.ADMIN]}>
              <AdminDashboard />
            </AuthGuard>
          }
        />
        <Route
          path="/evaluator-dashboard"
          element={
            <AuthGuard allowedRoles={[environment.ROLE_IDS.EVALUATOR]}>
              <EvaluatorDashboard />
            </AuthGuard>
          }
        />
        <Route
          path="/evaluator-task"
          element={
            <AuthGuard allowedRoles={[environment.ROLE_IDS.EVALUATOR]}>
              <EvaluatorPage />
            </AuthGuard>
          }
        />
        <Route
          path="/create-test"
          element={
            <AuthGuard allowedRoles={[environment.ROLE_IDS.ADMIN]}>
              <CreateTest />
            </AuthGuard>
          }
        />
        <Route
          path="/upload-answer-sheet"
          element={
            <AuthGuard allowedRoles={[environment.ROLE_IDS.ADMIN]}>
              <AnswerSheetUpload />
            </AuthGuard>
          }
        />
        <Route
          path="/exam-session"
          element={
            <AuthGuard allowedRoles={[environment.ROLE_IDS.ADMIN]}>
              <ExamSession />
            </AuthGuard>
          }
        />
        <Route path="/" element={<HomePage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </div>
      </div>
    </>
  );
}

function App() {
  return (
    <Providers>
      <Router>
        <AppContent />
      </Router>
    </Providers>
  );
}

export default App;
